import { render, staticRenderFns } from "./MyTrainingPrograms.vue?vue&type=template&id=23cfdf95&scoped=true&"
import script from "./MyTrainingPrograms.vue?vue&type=script&lang=js&"
export * from "./MyTrainingPrograms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cfdf95",
  null
  
)

export default component.exports